<template>
  <div class="group-box">
    <div class="box-title">
      <div class="title f-16 f-c-999">保洁配置</div>
    </div>
    <div v-for="(item, index) in list" :key="index" class="box-list">
      <div class="list-lef">{{ item.label }}</div>
      <div class="list-rig f-20 f-c-999">
        <a-switch v-model:checked="item.value" @change="changeSwitch"/>
      </div>
    </div>
  </div>
</template>

<script>
import {onMounted, reactive, toRefs} from "vue";
import {taskGetConfig, taskSaveConfig} from "@/api/api";
import {message} from "ant-design-vue";

export default {
  components: {},
  setup() {
    const config = reactive({
      list: [
        {
          label: "退房日自动创建",
          key: "checkOutDay",
          value: false,
        },
        {
          label: "退房时自动创建",
          key: "checkOut",
          value: false,
        },
        {
          label: "接收任务开始通知",
          key: "taskStart",
          value: false,
        },
        {
          label: "接收任务完成通知",
          key: "taskEnd",
          value: false,
        },
        {
          label: "接收任务创建/变更/取消通知",
          key: "taskCreate",
          value: false,
        },
      ],
      changeSwitch() {
        let params = {};
        config.list.forEach((i) => {
          params[i.key] = i.value ? 1 : 2;
        });
        taskSaveConfig(params).then((res) => {
          message.success(res.msg);
          config.getConfig();
        });
      },
      getConfig() {
        taskGetConfig().then((res) => {
          config.list.forEach((i) => {
            i.value = res.data[i.key] == 1 ? true : false;
          });
        });
      },
    });

    onMounted(() => {
      config.getConfig();
    });

    return {
      ...toRefs(config),
    };
  },
};
</script>

<style lang="scss" scoped>
.group-box {
  background-color: #fff;
  width: 50%;
  box-shadow: 0 0 5px #99999933;

  .box-title {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    border-bottom: 1px solid #f2f2f2;

    .title {
    }

    .btn {
    }
  }

  .box-list {
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .list-lef {
      .lef-name {
        margin-bottom: 5px;
      }

      .lef-num {
      }
    }

    .list-rig {
      display: flex;
    }
  }
}
</style>
